export const AUTH_CHANGED_EVENT = 'c168-auth-changed';

export const OPEN_LOGIN_MODAL_EVENT = 'c168-open-login-modal';

export function dispatchAuthChanged() {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(AUTH_CHANGED_EVENT));
  }
}

export function dispatchOpenLoginModal() {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(OPEN_LOGIN_MODAL_EVENT));
  }
}
